import Vue from 'vue'
import { api } from '@/api'
import AssetsManager from '@appmax_npm/ds-appmax'
import 'bootstrap/dist/css/bootstrap.css'
import VueTheMask from 'vue-the-mask'
import VueCookies from 'vue-cookies'
import { VueMaskFilter } from 'v-mask'
import Hotjar from 'vue-hotjar'
import i18n from '@/plugins/i18n'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import { isProduction } from '@/utils/environment'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/_default.scss'
import '@appmax_npm/ds-appmax/dist/ds-appmax.css'
import '@appmax_npm/ds-appmax/dist/core.scss'
import '@appmax_npm/security_flashlight'

// Globals and config
Vue.config.productionTip = false
Vue.prototype.$api = api

// Use
Vue.use(AssetsManager, { registerComponents: true })
Vue.use(VueTheMask)
Vue.use(VueCookies)
Vue.filter('VMask', VueMaskFilter)
Vue.use(ApmVuePlugin, {
  router,
  config: {
    serviceName: process.env.VUE_APP_ELASTIC_APM_SVC_NAME,
    serverUrl: 'https://appmax-aws-obs-01.apm.sa-east-1.aws.found.io:443',
    environment: process.env.VUE_APP_ELASTIC_APM_ENV,
    secretToken: 'DQKrgB8w7wsKsFzVBS',
  },
})

const hotjarId = process.env.VUE_APP_HOTJAR_ID.replace(/"/g, '')

if (isProduction()) {
  Vue.use(Hotjar, {
    id: hotjarId,
    isProduction: isProduction(),
  })
}

new Vue({
  router,
  store,
  render: (h) => h(App),
  i18n,
}).$mount('#app')
